import { z } from 'zod';

const looseObject = z.union([z.record(z.string(), z.any()), z.object({}).passthrough()]);

/** Body for POST /workflow-templates/trigger-condition-preview */
export const triggerConditionPreviewBodySchema = z.object({
    condition: z.string().max(8000).optional().default(''),
    sampleEntity: looseObject.optional().default({}),
    actor: looseObject.optional(),
});
